import { GlobalStore } from '@roc/feature-app-core';
import { LoanService, LoanStore } from '@roc/feature-loans';
import { CLOSING } from '@roc/feature-utils';
import { flow, makeObservable, observable } from 'mobx';
import { LoanActionsService } from '../services/loanActionsService';

export class RequestClosingWireStore {
  private globalStore: GlobalStore;
  private loanStore: LoanStore;

  private loanActionsService: LoanActionsService;

  checkResult;

  constructor(globalStore: GlobalStore, loanStore: LoanStore) {
    this.globalStore = globalStore;
    this.loanStore = loanStore;

    this.loanActionsService = new LoanActionsService();

    makeObservable(this, {
      checkResult: observable,
      checkRequirements: flow,
      requestClosingWire: flow,
    });
  }

  resetStore() {
    this.checkResult = null;
  }

  *checkRequirements() {
    try {
      const { loanId } = this.loanStore.loanDetails;
      const response = yield this.loanActionsService.checkRequirementsForRequestClosingWire(
        loanId
      );
      this.checkResult = response.data.data;
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message:
          'Requirements are not ready for requesting the closing wire',
      });
    }
  }

  *requestClosingWire() {
    try {
      const { loanId } = this.loanStore.loanDetails;
      yield this.loanActionsService.requestClosingWire(loanId);
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Closing wire requested successfully.',
      });
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Failed to request closing wire.',
      });
    }
  }
}
